let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("10LUZ")).then(() => parcelRequire('d67LW'));